import { useState, type ReactNode } from 'react';

import { api } from '../../api';
import { Aviso, Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * Onde o modelo roda e com que credencial.
 */
export function SecaoIa({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [ia, setIa] = useState({
    modo: c.ia.modo,
    baseUrl: c.ia.baseUrl ?? '',
    modelo: c.ia.modelo ?? '',
    chave: '',
  });
  const [testeIa, setTesteIa] = useState<{
    ok: boolean;
    detalhe: string;
  } | null>(null);

  return (
    <Painel titulo="Inteligência artificial">
      <Campo rotulo="Modo">
        <select
          value={ia.modo}
          disabled={!podeEditar}
          onChange={(e) => setIa({ ...ia, modo: e.target.value as typeof ia.modo })}
        >
          <option value="simulado">Simulado</option>
          <option value="local">Local (dentro do ambiente)</option>
          <option value="remoto">Remoto (sai do ambiente)</option>
          <option value="desligado">Desligado</option>
        </select>
      </Campo>

      {ia.modo === 'remoto' && (
        <Aviso tipo="alerta">
          Conteúdo de chamados e inventário será enviado para um serviço externo.
        </Aviso>
      )}

      {(ia.modo === 'local' || ia.modo === 'remoto') && (
        <div className="grade2">
          <Campo rotulo="Endereço">
            <input
              value={ia.baseUrl}
              disabled={!podeEditar}
              onChange={(e) => setIa({ ...ia, baseUrl: e.target.value })}
            />
          </Campo>
          <Campo rotulo="Modelo">
            <input
              value={ia.modelo}
              disabled={!podeEditar}
              onChange={(e) => setIa({ ...ia, modelo: e.target.value })}
            />
          </Campo>
          {ia.modo === 'remoto' && (
            <Campo
              rotulo="Chave de API"
              ajuda={c.ia.chaveDefinida ? 'Já gravada. Em branco mantém.' : undefined}
            >
              <input
                type="password"
                value={ia.chave}
                disabled={!podeEditar}
                placeholder={c.ia.chaveDefinida ? '••••••••' : ''}
                onChange={(e) => setIa({ ...ia, chave: e.target.value })}
              />
            </Campo>
          )}
        </div>
      )}

      <div className="linha">
        <button
          className="encolhe"
          disabled={acao.executando || !podeEditar}
          onClick={() =>
            void acao.rodar(async () => {
              setTesteIa(
                await api.post<{ ok: boolean; detalhe: string }>('/api/config/ia/testar', ia),
              );
              return null;
            })
          }
        >
          Testar
        </button>
        <button
          className="primario encolhe"
          disabled={acao.executando || !podeEditar}
          onClick={() => salvar('ia', ia, 'IA')}
        >
          Salvar
        </button>
        <span className="cresce" />
      </div>
      {testeIa !== null && <Aviso tipo={testeIa.ok ? 'ok' : 'erro'}>{testeIa.detalhe}</Aviso>}
    </Painel>
  );
}
